import React, { useState } from "react";
import { Link } from "react-router-dom";
function Footer()
{
  const [popularSearchesOpen, setPopularSearchesOpen] = useState(false);

   return  (
<> 
  <footer className="footer footer-modern"><a href="tel:+971544544287">
    <button className="btn-floating phone">
      <img src={process.env.PUBLIC_URL + "/assets/images/phone.webp"} alt="Phone" />
      <span>+971 26446368</span>
    </button>
  </a>
  <a href="https://api.whatsapp.com/send?phone=971501577822" target="_blank">
    <button className="btn-floating whatsapp">
      <img src={process.env.PUBLIC_URL + "/assets/images/whatsapp.webp"} alt="WhatsApp" />
      <span>+971 50 157 7822</span>
    </button>
  </a>
    <div className="container">
      <div className="footer-modern-main">
        <div className="footer-newsletter">
          <h3>Nova Vision Real Estate Agency</h3>
          <p>
            At NV Real Estate, we specialize in connecting clients with their
            dream properties in Abu Dhabi and beyond. Whether you are looking
            for commercial real estate, a house for sale, or simply exploring
            the latest in property trends, we offer unparalleled expertise to
            guide your investment journey.
          </p>
          <div id="responsenl" />
          <div className="social-wrapper">
            <div className="social-links" style={{ float: 'left' }}>
              <a
                href="https://www.instagram.com/nvrealestate_uae"
                target="_blank"
                className="instagram"
              >
                <i className="fab fa-instagram" />
              </a>
              <a
                href="https://www.facebook.com/nvrealestate.uae"
                target="_blank"
                className="facebook"
              >
                <i className="fab fa-facebook-f" />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                className="linkedin"
              >
                <i className="fab fa-linkedin-in" />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-modern-links">
          <div className="footer-link-group">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/properties-for-sale" data-discover="true">
                  Properties For Sales
                </Link>
              </li>
              <li>
                <Link to="/properties-for-rent" data-discover="true">
                  Properties For Rent
                </Link>
              </li>
              <li>
                <Link to="/sell-your-property" data-discover="true">
                  Sell Your Property
                </Link>
              </li>
              <li>
                <Link to="/new-projects" data-discover="true">
                  New Projects
                </Link>
              </li>
              <li>
                <Link to="/luxury-collection" data-discover="true">
                  Luxury Collections
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-link-group">
            <h4>Services</h4>
            <ul>
            
              <li>
                <Link to="/mortgage" data-discover="true">
                   Mortgage Advisory 
                </Link>
              </li>
              <li>
                <Link to="/property-management" data-discover="true">
                  Property Management
                </Link>
              </li>
               
              <li>
                <Link to="/golden-visa-and-property-residency" data-discover="true">
                  Golden Visa & Property Residency
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-link-group">
            <h4>About</h4>
            <ul>
              <li>
                <Link to="/about-us" data-discover="true">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/team" data-discover="true">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/testimonials" data-discover="true">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/blogs" data-discover="true">
                  Market News & Trends
                </Link>
              </li>
              <li>
                <Link to="/contact-us" data-discover="true">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`popular-searches ${popularSearchesOpen ? "is-open" : ""}`}>
        <button
          type="button"
          className="popular-searches-toggle"
          aria-expanded={popularSearchesOpen}
          aria-controls="popularSearchLinks"
          onClick={() => setPopularSearchesOpen((isOpen) => !isOpen)}
        >
          <span>Popular Searches</span>
          <span className="popular-searches-arrow" aria-hidden="true" />
        </button>
        <div
          id="popularSearchLinks"
          className="popular-searches-panel"
          aria-hidden={!popularSearchesOpen}
        >
          <div className="popular-searches-grid">
            <Link to="/properties-for-sale" data-discover="true">
              Properties for Sale
            </Link>
            <Link to="/new-projects" data-discover="true">
              Off Plan Properties Abu Dhabi
            </Link>
            <Link to="/property-search-result?offering_type=Sale&property_category=Residential&property_type=Apartment"
              data-discover="true"
            >
              Apartments to buy in Abu Dhabi
            </Link>
            <Link to="/property-search-result?offering_type=Rent&city=&property_category=Residential&property_type=Apartment&bedrooms=2&bathrooms=&minArea=&maxArea=&minPrice=&maxPrice="
              data-discover="true"
            >
              2 BHK for rent
            </Link>
            <Link to="/property-search-result?offering_type=Rent&property_category=Residential&bedrooms=1"
              data-discover="true"
            >
              1 bedroom apartment for rent
            </Link>
            <Link to="/property-search-result?offering_type=Sale&city=&property_category=Residential&property_type=Villa&bedrooms=1&bathrooms=&minArea=&maxArea=&minPrice=&maxPrice="
              data-discover="true"
            >
              Villa for sale Abu Dhabi
            </Link>
            <Link to="/property-search-result?offering_type=Sale&city=&property_category=Residential&property_type=Townhouse&bedrooms=1&bathrooms=&minArea=&maxArea=&minPrice=&maxPrice="
              data-discover="true"
            >
              Abu Dhabi Townhouses for Sale
            </Link>
            <Link to="/property-search-result?offering_type=Sale&city=&property_category=Residential&property_type=Apartment&bedrooms=2&bathrooms=&minArea=&maxArea=&minPrice=&maxPrice="
              data-discover="true"
            >
              2 bedroom apartment for sale
            </Link>
            <Link to="/property-search-result?offering_type=Rent&city=&property_category=Residential&property_type=Apartment&bedrooms=3&bathrooms=&minArea=&maxArea=&minPrice=&maxPrice="
              data-discover="true"
            >
              3 BHK for rent in Abu Dhabi
            </Link>
            <Link to="/property-search-result?offering_type=Rent&city=&property_category=Residential&property_type=Penthouse&bedrooms=&bathrooms=&minArea=&maxArea=&minPrice=&maxPrice="
              data-discover="true"
            >
              Penthouse for sale in Abu Dhabi
            </Link>
            <Link to="/property-search-result?offering_type=Rent&city=&property_category=Residential&property_type=Villa&bedrooms=&bathrooms=&minArea=&maxArea=&minPrice=&maxPrice="
              data-discover="true"
            >
              Villas for rent in Abu Dhabi
            </Link>
            <Link to="/luxury-collection" data-discover="true">
              Luxury Properties
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-modern-bottom">
        <span>© Nova Vision Real Estate Broker. All rights reserved.</span>
        <div>
          <Link to="/terms-and-conditions" data-discover="true">
            Terms &amp; Conditions
          </Link>
          <Link to="/privacy-policy" data-discover="true">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  </footer>
  
  
<div className="progress-wrap">
  <svg
    className="progress-circle svg-content"
    width="100%"
    height="100%"
    viewBox="-1 -1 102 102"
  >
    <path
      d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
      style={{
        transition: "stroke-dashoffset 10ms linear 0s",
        strokeDasharray: "307.919, 307.919",
        strokeDashoffset: "286.138"
      }}
    />
  </svg>
</div>
</>
);
}export default Footer;
